<template>
    <q-table
        ref="table"
        :data="stars"
        :columns="columns_stars"
        row-key="id"
        :pagination.sync="server_pagination"
        @request="requestStars"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="user_full_name" :props="props">
                    {{ props.row.user_full_name }}
                </q-td>

                <q-td key="user_email" :props="props">
                    {{ props.row.user_email }}
                </q-td>

                <q-td key="evaluate_date" :props="props">
                    {{ fDate(props.row.evaluate_date) }}
                </q-td>

                <q-td key="stars" :props="props">
                    {{ props.row.stars }}
                </q-td>

                <q-td key="comment" :props="props">
                    {{ props.row.comment }}
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['load', 'id', 'permissions'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            stars: [],
            columns_stars: [
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: true,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: true,
                },
                {
                    name: 'evaluate_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'evaluate_date',
                    sortable: true,
                },
                {
                    name: 'stars',
                    required: true,
                    label: 'rating',
                    align: 'left',
                    field: 'stars',
                    sortable: true,
                },
                {
                    name: 'comment',
                    required: true,
                    label: 'comment',
                    align: 'left',
                    field: 'comment',
                    sortable: false,
                }
            ],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        requestStars({ pagination }) {
            this.stars = []
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_webcasts/webcasts/${this.id}/webcast_user_stars/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                response.data.results.map((e) => {
                    this.stars.push(e)
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestStars({ pagination: this.server_pagination })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.requestStars({ pagination: this.server_pagination })
    }
}
</script>

<style>

</style>
